import { render, staticRenderFns } from "./member-counter-card.vue?vue&type=template&id=5973df0c&scoped=true"
import script from "./member-counter-card.vue?vue&type=script&lang=js"
export * from "./member-counter-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973df0c",
  null
  
)

export default component.exports